var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "g",
    {
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("circle", {
        attrs: {
          cx: "29",
          cy: "16",
          r: "15.5",
          fill: "white",
          "fill-opacity": "0.01",
          stroke: "#E73C14",
        },
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M32.4399 10.9901C32.462 11.0182 32.4854 11.0452 32.51 11.0709C31.5128 11.2579 30.5714 11.6908 29.7747 12.338C29.3517 12.6816 28.9795 13.0775 28.6654 13.5138C28.8895 13.7498 29.0916 14.0038 29.2702 14.2726C29.5028 13.9129 29.7815 13.5812 30.1015 13.2866C31.0365 12.4261 32.258 11.944 33.5287 11.934C34.7993 11.924 36.0283 12.3869 36.9767 13.2326C37.925 14.0784 38.525 15.2466 38.6599 16.5101L38.7099 17.0301L38.6499 17.5401C38.4836 18.7791 37.8705 19.9146 36.9259 20.7335C35.9814 21.5524 34.7703 21.9982 33.5202 21.9871C32.2702 21.9761 31.0672 21.5089 30.1372 20.6735C29.898 20.4586 29.681 20.223 29.4883 19.9706C29.3221 20.2671 29.129 20.5487 28.9109 20.8115C29.174 21.1258 29.47 21.4144 29.7953 21.672C30.8883 22.5372 32.2461 22.9992 33.64 22.9801C35.0297 22.9946 36.3825 22.5334 37.4739 21.673C38.5654 20.8126 39.3297 19.6048 39.64 18.2501C39.9406 18.2227 40.2201 18.0838 40.4236 17.8609C40.6272 17.6379 40.7401 17.347 40.7401 17.0451C40.7401 16.7432 40.6272 16.4522 40.4236 16.2292C40.2201 16.0063 39.9406 15.8675 39.64 15.8401C39.3516 14.4622 38.5977 13.2256 37.5051 12.338C36.5448 11.5578 35.3741 11.089 34.1488 10.987L35.7599 9.01012L34.9899 8.37012L33.36 10.3701H33.2299L32.6599 9.63011L31.8699 10.2501L32.4399 10.9901ZM39.4699 17.2201L39.2499 17.0601L39.4699 16.9301C39.4957 16.9029 39.5292 16.8844 39.5659 16.8772C39.6026 16.87 39.6407 16.8743 39.6748 16.8897C39.7089 16.9051 39.7373 16.9308 39.7562 16.9631C39.775 16.9954 39.7833 17.0328 39.7799 17.0701C39.7799 17.2201 39.6699 17.3701 39.4699 17.2201Z",
          fill: "#E73C14",
        },
      }),
      _c("path", {
        attrs: {
          d: "M31.2597 17.3599H32.4699V16.3599H31.15V17.0035C31.2176 17.1095 31.256 17.2325 31.2597 17.3599Z",
          fill: "#E73C14",
        },
      }),
      _c("path", {
        attrs: {
          d: "M36.02 16.3599H34.7V17.3599H36.02V16.3599Z",
          fill: "#E73C14",
        },
      }),
      _c("path", {
        attrs: {
          d: "M33.4699 20.5601H33.8099V20.5901C34.0642 20.5902 34.3159 20.5395 34.5502 20.441C34.7846 20.3425 34.997 20.1982 35.1749 20.0166C35.3528 19.835 35.4926 19.6197 35.5862 19.3833C35.6798 19.147 35.7253 18.8943 35.7199 18.6401H34.7199C34.7226 18.7613 34.701 18.8818 34.6565 18.9945C34.612 19.1072 34.5453 19.2099 34.4606 19.2966C34.3758 19.3832 34.2746 19.452 34.1629 19.499C34.0511 19.546 33.9311 19.5701 33.8099 19.5701H33.4699C33.3474 19.5688 33.2263 19.5431 33.1139 19.4944C33.0014 19.4457 32.8998 19.3751 32.8151 19.2866C32.7303 19.1981 32.6641 19.0935 32.6203 18.9791C32.5765 18.8646 32.5559 18.7426 32.5599 18.6201H32.0599L31.5599 18.6801C31.5704 19.1806 31.7759 19.6573 32.1327 20.0085C32.4895 20.3597 32.9693 20.5576 33.4699 20.5601Z",
          fill: "#E73C14",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.4199 16.7H22.0999V17.7H23.4199V16.7Z",
          fill: "#E73C14",
        },
      }),
      _c("path", {
        attrs: { d: "M25.65 16.7H26.9699V17.7H25.65V16.7Z", fill: "#E73C14" },
      }),
      _c("path", {
        attrs: {
          d: "M24.7499 20.93H24.4099C23.9103 20.9274 23.4315 20.7292 23.0763 20.3777C22.7211 20.0262 22.5178 19.5496 22.5099 19.05L23.5099 18.98C23.5073 19.1021 23.5287 19.2236 23.573 19.3374C23.6173 19.4513 23.6836 19.5553 23.7681 19.6435C23.8526 19.7317 23.9537 19.8024 24.0655 19.8516C24.1774 19.9007 24.2978 19.9274 24.42 19.93H24.7599C24.8808 19.9304 25.0005 19.9067 25.1121 19.8604C25.2237 19.814 25.325 19.7459 25.4099 19.66C25.4972 19.5744 25.5655 19.4714 25.6103 19.3577C25.6551 19.244 25.6754 19.1221 25.67 19H26.67C26.6767 19.2545 26.6321 19.5078 26.539 19.7448C26.4459 19.9818 26.3061 20.1976 26.128 20.3795C25.9498 20.5614 25.7369 20.7057 25.5019 20.8036C25.2669 20.9016 25.0146 20.9514 24.7599 20.95L24.7499 20.93Z",
          fill: "#E73C14",
        },
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M23.4278 11.3755C23.4148 11.3607 23.4021 11.3455 23.39 11.33L22.8199 10.59L23.5999 9.96996L24.1799 10.71L24.6899 11.03L24.3099 10.71L25.9399 8.70996L26.7099 9.34996L25.1282 11.2907C26.3451 11.4002 27.506 11.872 28.4577 12.6514C29.5514 13.5472 30.3013 14.7941 30.5799 16.1801C30.8982 16.1801 31.2034 16.3066 31.4285 16.5316C31.6535 16.7566 31.7799 17.0619 31.7799 17.3801C31.7799 17.6984 31.6535 18.0036 31.4285 18.2287C31.2034 18.4537 30.8982 18.5801 30.5799 18.5801C30.2716 19.9367 29.5082 21.1468 28.4166 22.0092C27.325 22.8715 25.971 23.3342 24.5799 23.3201C23.1861 23.3393 21.8283 22.8773 20.7353 22.012C19.6424 21.1468 18.8811 19.9312 18.5799 18.5701C18.4138 18.5853 18.2463 18.5658 18.0882 18.5126C17.9301 18.4595 17.7848 18.374 17.6616 18.2615C17.5384 18.1491 17.44 18.0122 17.3726 17.8595C17.3053 17.7069 17.2705 17.542 17.2705 17.3751C17.2705 17.2083 17.3053 17.0433 17.3726 16.8907C17.44 16.7381 17.5384 16.6012 17.6616 16.4888C17.7848 16.3763 17.9301 16.2908 18.0882 16.2376C18.2463 16.1845 18.4138 16.1649 18.5799 16.1801C18.8585 14.7941 19.6084 13.5472 20.7022 12.6514C21.4951 12.0021 22.4331 11.5662 23.4278 11.3755ZM19.4699 17.7901C19.623 19.0241 20.219 20.1604 21.1471 20.9878C22.0752 21.8153 23.2722 22.2774 24.5155 22.2885C25.7589 22.2995 26.9639 21.8585 27.9065 21.0477C28.8491 20.2368 29.4651 19.1112 29.64 17.8801L29.7 17.3601V16.8501C29.6323 15.5325 29.0586 14.2919 28.0984 13.3869C27.1383 12.482 25.866 11.9826 24.5466 11.9929C23.2273 12.0033 21.9629 12.5225 21.0171 13.4423C20.0713 14.3621 19.517 15.6116 19.4699 16.9301V17.7901ZM30.2599 17.3901L30.4699 17.5501C30.5399 17.6001 30.5699 17.6001 30.5799 17.6001C30.607 17.6015 30.6341 17.5973 30.6595 17.5879C30.685 17.5784 30.7082 17.5639 30.7279 17.5452C30.7475 17.5265 30.7631 17.504 30.7738 17.479C30.7845 17.4541 30.79 17.4273 30.7899 17.4001C30.7887 17.3646 30.778 17.3301 30.759 17.3001C30.74 17.2701 30.7134 17.2456 30.6818 17.2294C30.6502 17.2131 30.6149 17.2055 30.5794 17.2074C30.5439 17.2093 30.5096 17.2206 30.4799 17.2401L30.2599 17.3901ZM18.4699 17.1801C18.4169 17.1801 18.366 17.2012 18.3285 17.2387C18.291 17.2762 18.2699 17.3271 18.2699 17.3801C18.2699 17.5601 18.54 17.5901 18.61 17.5101L18.7299 17.3701L18.61 17.2401C18.5924 17.2205 18.5708 17.205 18.5466 17.1946C18.5224 17.1842 18.4962 17.1793 18.4699 17.1801Z",
          fill: "#E73C14",
        },
      }),
      _c("path", {
        attrs: {
          d: "M15.22 35.77V39.07H15.55V40.33H15.18V39.44H12.78V40.33H12.37V39.07H12.65C12.798 38.8133 12.9186 38.5419 13.01 38.26C13.1464 37.7551 13.2071 37.2328 13.19 36.71V35.77H15.22ZM13.6 36.86C13.6169 37.3702 13.5527 37.8799 13.41 38.37C13.3381 38.6144 13.2374 38.8494 13.11 39.07H14.75V36.17H13.6V36.86Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.06 37.73H16.63V39.07H18.22V39.47H16.15V35.77H18.15V36.17H16.63V37.34H18.06V37.73Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.57 36.18H18.47V35.77H21.18V36.18H20.05V39.46H19.57V36.18Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.98 39.34C23.6646 39.4751 23.3227 39.5367 22.98 39.52C22.7323 39.5352 22.4842 39.4969 22.2525 39.4077C22.0209 39.3186 21.8112 39.1806 21.6376 39.0032C21.464 38.8258 21.3306 38.6132 21.2465 38.3797C21.1623 38.1462 21.1294 37.8973 21.15 37.65C21.1356 37.3923 21.1756 37.1345 21.2674 36.8933C21.3592 36.6521 21.5007 36.4329 21.6827 36.2499C21.8647 36.067 22.0832 35.9244 22.3239 35.8313C22.5646 35.7383 22.8222 35.697 23.08 35.71C23.3826 35.6968 23.6841 35.755 23.96 35.88L23.84 36.26C23.6187 36.149 23.3771 36.0844 23.13 36.07C22.9309 36.0586 22.7318 36.0907 22.5465 36.1642C22.3611 36.2377 22.1941 36.3508 22.0569 36.4955C21.9198 36.6403 21.8159 36.8132 21.7526 37.0022C21.6892 37.1913 21.6678 37.3918 21.69 37.59C21.6676 37.7851 21.6883 37.9827 21.7507 38.1689C21.8131 38.3551 21.9157 38.5252 22.0512 38.6674C22.1867 38.8095 22.3517 38.9202 22.5347 38.9915C22.7177 39.0628 22.9141 39.093 23.11 39.08C23.3774 39.0826 23.6426 39.0316 23.89 38.93L23.98 39.34Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M25.05 35.77V37.41H25.2L26.47 35.77H27.04L25.64 37.46C25.8881 37.5062 26.1165 37.6265 26.295 37.805C26.4735 37.9835 26.5937 38.2119 26.64 38.46C26.7565 38.8013 26.8934 39.1352 27.05 39.46H26.57C26.436 39.1797 26.3256 38.8887 26.24 38.59C26.1974 38.3571 26.0735 38.1468 25.8903 37.9966C25.7072 37.8465 25.4767 37.7662 25.24 37.77H25.05V39.46H24.58V35.77H25.05Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M28 35.77V37.33C28 37.91 28 38.39 28 38.89C28.2049 38.4716 28.4319 38.0643 28.68 37.67L29.88 35.77H30.35V39.46H29.87V37.89C29.87 37.29 29.87 36.89 29.87 36.39C29.6706 36.8209 29.4435 37.2385 29.19 37.64L28.06 39.46H27.55V35.77H28Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M31.61 35.77V37.33C31.61 37.91 31.61 38.39 31.56 38.89C31.75 38.51 31.98 38.11 32.25 37.67L33.47 35.77H33.95V39.46H33.47V37.89C33.47 37.29 33.47 36.89 33.47 36.39C33.2671 36.821 33.0366 37.2386 32.78 37.64L31.67 39.46H31.16V35.77H31.61ZM32.21 35C32.21 35.17 32.29 35.34 32.54 35.34C32.79 35.34 32.85 35.18 32.88 35H33.24C33.24 35.36 33 35.59 32.53 35.59C32.4449 35.6029 32.3579 35.5974 32.2751 35.5737C32.1923 35.55 32.1156 35.5088 32.0501 35.4528C31.9846 35.3968 31.932 35.3274 31.8957 35.2493C31.8595 35.1711 31.8405 35.0861 31.84 35H32.21Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M38.47 39.34C38.1546 39.4751 37.8126 39.5367 37.47 39.52C37.2222 39.5352 36.9741 39.4969 36.7425 39.4077C36.5109 39.3186 36.3012 39.1806 36.1276 39.0032C35.954 38.8258 35.8206 38.6132 35.7365 38.3797C35.6523 38.1462 35.6194 37.8973 35.64 37.65C35.6256 37.3923 35.6656 37.1345 35.7574 36.8933C35.8492 36.6521 35.9907 36.4329 36.1727 36.2499C36.3547 36.067 36.5732 35.9244 36.8139 35.8313C37.0546 35.7383 37.3122 35.697 37.57 35.71C37.8726 35.6968 38.174 35.755 38.45 35.88L38.33 36.26C38.0965 36.1588 37.8444 36.1077 37.59 36.11C37.3909 36.0986 37.1918 36.1307 37.0064 36.2042C36.8211 36.2777 36.6541 36.3908 36.5169 36.5355C36.3798 36.6803 36.2759 36.8532 36.2126 37.0422C36.1492 37.2313 36.1278 37.4318 36.15 37.63C36.1276 37.8251 36.1483 38.0227 36.2107 38.2089C36.2731 38.3951 36.3757 38.5652 36.5112 38.7074C36.6467 38.8495 36.8117 38.9602 36.9947 39.0315C37.1776 39.1028 37.374 39.133 37.57 39.12C37.8342 39.1235 38.0964 39.0724 38.34 38.97L38.47 39.34Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M39.72 38.3L39.34 39.46H38.84L40.1 35.77H40.67L41.93 39.46H41.47L41.08 38.3H39.72ZM40.93 37.93L40.57 36.87C40.49 36.63 40.43 36.41 40.38 36.19C40.32 36.41 40.26 36.64 40.19 36.86L39.83 37.93H40.93Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M45.14 35.77V39.07H45.47V40.33H45.1V39.44H42.7V40.33H42.33V39.07H42.61C42.762 38.8154 42.8828 38.5435 42.97 38.26C43.1064 37.7551 43.1671 37.2328 43.15 36.71V35.77H45.14ZM43.52 36.86C43.5349 37.3695 43.4742 37.8783 43.34 38.37C43.2595 38.6113 43.1591 38.8454 43.04 39.07H44.67V36.17H43.52V36.86Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M1.16999 46.4501L2.25999 47.9401H1.67999L0.609985 46.4501L1.67999 44.9601H2.25999L1.16999 46.4501ZM2.49999 46.4501L3.57999 47.9401H3.00999L1.93999 46.4501L3.00999 44.9601H3.57999L2.49999 46.4501Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M7.21002 45.9299H5.09002V47.9299H7.47002V48.5199H4.40002V43.0699H7.34002V43.6599H5.10002V45.3799H7.22002L7.21002 45.9299Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M8.37 48.4899V43.0699H9.14L10.89 45.8299C11.2578 46.3998 11.5917 46.9908 11.89 47.5999C11.82 46.8699 11.8 46.1999 11.8 45.3499V43.0699H12.47V48.5299H11.76L10.02 45.7599C9.65109 45.1701 9.31718 44.559 9.02 43.9299C9.02 44.6199 9.07 45.2799 9.07 46.1799V48.5199L8.37 48.4899Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.85 48.2399C17.3151 48.4367 16.7499 48.5382 16.18 48.5399C15.4445 48.5733 14.7256 48.3144 14.18 47.8199C13.9266 47.5535 13.7282 47.2397 13.5961 46.8965C13.464 46.5534 13.4007 46.1875 13.41 45.8199C13.3969 45.4305 13.4669 45.0427 13.6155 44.6825C13.7641 44.3223 13.9879 43.9979 14.2718 43.731C14.5557 43.4641 14.8933 43.2608 15.262 43.1348C15.6307 43.0087 16.0221 42.9627 16.41 42.9999C16.8756 42.9898 17.3384 43.0749 17.77 43.2499L17.6 43.8299C17.2196 43.6607 16.8062 43.5787 16.39 43.5899C16.0942 43.56 15.7954 43.5965 15.5154 43.6966C15.2354 43.7968 14.9813 43.9581 14.7715 44.1688C14.5617 44.3796 14.4016 44.6344 14.3027 44.9148C14.2039 45.1953 14.1688 45.4942 14.2 45.7899C14.1705 46.0784 14.204 46.3698 14.2984 46.644C14.3927 46.9182 14.5455 47.1687 14.7462 47.3779C14.9469 47.5872 15.1907 47.7504 15.4608 47.856C15.7308 47.9617 16.0206 48.0074 16.31 47.9899C16.6296 48.0069 16.9493 47.9593 17.25 47.8499V46.2199H16.06V45.6499H17.85V48.2399Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.9299 43.0699H19.6299V47.9399H21.9699V48.5299H18.9699L18.9299 43.0699Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.47 43.0699V48.5299H22.75V43.0699H23.47Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.59 47.63C24.9717 47.8573 25.4059 47.9813 25.85 47.99C26.58 47.99 27 47.61 27 47.05C27 46.49 26.7 46.25 26 45.97C25.11 45.65 24.56 45.19 24.56 44.42C24.5708 44.2045 24.6258 43.9935 24.7218 43.8002C24.8177 43.6069 24.9525 43.4355 25.1176 43.2966C25.2828 43.1577 25.4748 43.0544 25.6817 42.993C25.8886 42.9317 26.1059 42.9136 26.32 42.94C26.7183 42.9371 27.1118 43.0261 27.47 43.2L27.27 43.78C26.9637 43.611 26.6199 43.5216 26.27 43.52C25.52 43.52 25.27 43.97 25.27 44.34C25.27 44.71 25.6 45.1 26.35 45.34C27.28 45.7 27.75 46.14 27.75 46.95C27.75 47.76 27.09 48.57 25.81 48.57C25.3212 48.574 24.8394 48.4536 24.41 48.22L24.59 47.63Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M29.3899 43.0699V45.3499H32.0299V43.0699H32.7399V48.5299H32.0299V45.9699H29.3899V48.5299H28.6799V43.0699H29.3899Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M38.4699 45.9299H36.3799V47.9299H38.7499V48.5199H35.6799V43.0699H38.6299V43.6599H36.3799V45.3799H38.4699V45.9299Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M42.65 48.4899L41.96 47.2799C41.67 46.8199 41.49 46.5199 41.32 46.1999C41.16 46.5199 41.01 46.8099 40.73 47.2899L40.07 48.4899H39.26L40.93 45.7299L39.31 43.0699H40.13L40.85 44.3499C41.06 44.6999 41.21 44.9799 41.36 45.2699C41.51 44.9499 41.65 44.6999 41.85 44.3499L42.62 43.0699H43.47L41.77 45.6799L43.47 48.4899H42.65Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M47.11 45.9299H44.99V47.9299H47.36V48.5199H44.29V43.0699H47.24V43.6599H44.99V45.3799H47.11V45.9299Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M52.87 46.0699C52.87 45.3099 52.78 44.3899 52.79 43.7099C52.6 44.3499 52.37 45.0299 52.1 45.7899L51.1 48.4399H50.56L49.68 45.8399C49.42 45.0599 49.2 44.3599 49.05 43.7099C49.05 44.3899 48.99 45.3099 48.94 46.1299L48.8 48.4699H48.13L48.47 43.0699H49.37L50.3 45.7099C50.52 46.3799 50.71 46.9799 50.85 47.5499C50.99 46.9999 51.19 46.3999 51.43 45.7099L52.47 43.0699H53.37L53.71 48.5299H53.02L52.87 46.0699Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M54.35 44.9601H54.93L56.01 46.4501L54.93 47.9401H54.36L55.47 46.4501L54.35 44.9601ZM55.67 44.9601H56.25L57.33 46.4501L56.25 47.9401H55.68L56.76 46.4501L55.67 44.9601Z",
          fill: "black",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }